module.exports = __webpack_public_path__ + "img/icons B_16.671e4744.svg";